const INPUT_CLASS = ".input-file__input";
const widgets = document.querySelectorAll(".js-file-input");
[...widgets].forEach(widget => {
	widget.dataset.label = widget.querySelector(INPUT_CLASS).innerHTML;
	widget.addEventListener("change", changeHandler, false);
});

function changeHandler(e) {
	e.stopPropagation();
	const { target } = e;
	const label = this.querySelector(INPUT_CLASS);
	if (target.value) {
		label.innerHTML = target.value;
	} else {
		label.innerHTML = this.dataset.label;
	}
}
